export const EncondingSectionType = {
  AboutPage: 1,
  CustomSection: 2,
  Donate: 3,
  Gallery: 4,
  News: 5,
  Recruitment: 6,
  WelcomeMessage: 7,
  WelcomeMessagePreview: 8,
  MarketingCustomSection: 9,
  Alert: 10,
  DonatePreview: 11,
  RecruitmentPreview: 12,
  CustomSectionPreview: 13,
  GalleryPreview: 14,
  NewsPreview: 15,
  MarketingCustomSectionPreview: 16
}
